import { getData } from '../../_helpers/getData';
import React, { useEffect, useState, Component } from "react";
import axios from "axios";
import jwt_decode from "jwt-decode";
import Navbar from "./../../components/Navbar";
import TopBar from "./../../components/topbar";
import { subCategoryService, categoryService } from "../../_services";
import constant from '../../_config/constant';
import Footer from "./../../layout/footer";



export default function addCategory(props) {
  const [requesting, setRequest] = useState(false);
  const [name, setName] = useState("");
  const [categoryId, setCategory] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [description, setDescription] = useState("");

  const decoded = getData();

  function onCreatePost(e) {
    const postData = { name, description, categoryId };
    e.preventDefault();
    setRequest(true);
    subCategoryService.add(postData).then(
      objS => { props.history.push("/faqsubcategory"); },
      error => { console.log(error) }
    );
  }

  useEffect(() => {
    categoryService.list({}).then(
      objS => { setCategoryList(objS.data) },
      error => { console.log(error) }
    );
  }, []);

  return (
    <div>
      <TopBar user={decoded} title="Add Sub Category"/>

        <div className="deznav">
          <div className="deznav-scroll">
            <Navbar />
          </div>
        </div>

        <div className="content-body">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12">
                <div className="tab-content">
                  <div className="tab-pane active show" id="All">
                    <form onSubmit={onCreatePost} >
                      <div className="form-group row kimargin">
                        <label
                          for="staticEmail"
                          className="col-sm-2 col-form-label"
                        >
                          Name
                        </label>
                        <div className="col-sm-10">
                          <input
                            type="text"
                            name="name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            className="form-control"
                            placeholder="Name"
                            required
                          />
                        </div>
                      </div>

                      <div className="form-group row kimargin">
                        <label
                          for="staticEmail"
                          className="col-sm-2 col-form-label"
                        >
                          Description
                        </label>
                        <div className="col-sm-10">
                          <input
                            type="text"
                            name="description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            className="form-control"
                            placeholder="Description"
                            required
                          />
                        </div>
                      </div>

                      <div className="form-group row kimargin">
                        <label
                          for="staticEmail"
                          className="col-sm-2 col-form-label"
                        >
                          Category
                        </label>
                        <div className="col-sm-10">
                          <select
                            value={categoryId}
                            className="form-control"
                            onChange={(e) => setCategory(e.target.value)}
                            required>
                            <option value="">Select</option>
                            {categoryList.map((option) => (
                              <option value={option.id}>{option.name}</option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="form-group row kimargin">
                        <label
                          for="inputPassword"
                          className="col-sm-2 col-form-label"
                        >
                          &nbsp;
                        </label>
                        <div className="col-sm-10">
                          <button type="submit" className="btn btn-primary">
                            {requesting ? "Please wait ..." : "Add Category"}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
  );
}
